const location = window.location



// 
export const replace = uri=>{
  location.replace(uri)
}

// 
export const currentHref = location.href

export const currentOrigin = location.origin

export const currentHost = location.host

// 
export const hrefParams = (str=location.href)=>{
  let obj = {}
  let name,value;
  let num = str.indexOf("?") 
  str = str.substr(num+1)
  var arr=str.split("&")
  for(var i=0;i < arr.length;i++){ 
    num = arr[i].indexOf("=")
    if(num>0){
      name = arr[i].substr(0,num)
      value = arr[i].substr(num+1)
      obj[name] = value;
    }
  } 
  return obj;
}

// 
export const replaceToOrigin = (isToPath=true)=>{
  const uri = location.origin+`${isToPath?location.pathname:''}`
  replace(uri)
}